'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const SmsIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="SmsIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2228_112)">
          <path
            d="M9.49999 20.043C8.97599 19.948 1.36099 22.748 1.36099 22.748C3.20899 20.982 4.17699 19.255 3.94899 17.582C2.90353 16.7999 2.04964 15.7903 1.45193 14.6296C0.854222 13.4688 0.528357 12.1873 0.498993 10.882C0.499993 5.7 5.64799 1.5 12 1.5C18.352 1.5 23.5 5.7 23.5 10.882C23.5 16.064 18.352 20.265 12 20.265C11.1617 20.2655 10.3251 20.1912 9.49999 20.043Z"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.951 4.765C17.426 5.475 20 8.04 20 11.1C19.9719 12.0755 19.7096 13.0299 19.2351 13.8828C18.7607 14.7356 18.0881 15.4618 17.274 16"
            stroke="#3D517B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2228_112">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

SmsIcon.propTypes = {
  sx: PropTypes.object
}
